<template>
  <div>
    <div class="trees">
      <div class="radios" v-show="agents">
        <span class="title_cc">下级代理</span>
        <el-radio-group v-model="radio9" size="small" @change="checkTypechange">
          <el-radio label="0" border>单选</el-radio>
          <el-radio label="1" border>全选</el-radio>
        </el-radio-group>
      </div>

      <el-input placeholder="输入代理名称进行过滤" v-model="filterText" v-show="agents">
      </el-input>

      <el-tree class="filter-tree" :data="agentTreeData" :props="defaultProps" show-checkbox :check-strictly="checkTypes" node-key="AgentCode" default-expand-all :filter-node-method="filterNode" ref="tree2" @check="getCheckedNodes" :default-checked-keys="agentTreeDataS" v-show="agents">
      </el-tree>
    </div>
    <el-tabs v-model="activeName" @tab-click="handleClick" style="height: 100%;">
      <el-tab-pane label="所有客户" name="allClient">
      </el-tab-pane>
      <el-tab-pane label="成交明细" name="dealDetail">
      </el-tab-pane>
      <el-tab-pane label="出入金明细" name="withdrawalDetail">
      </el-tab-pane>
      <el-tab-pane label="委托" name="delegation">
      </el-tab-pane>
      <el-tab-pane label="资金" name="capital">
      </el-tab-pane>
      <el-tab-pane label="结算单" name="profit">
      </el-tab-pane>
      <el-tab-pane label="单量统计" name="order">
      </el-tab-pane>
      <el-tab-pane label="出入金统计" name="withCharge">
      </el-tab-pane>
      <div class="derive" v-show="isderive" style="position: fixed; top: 60px;">
        <button type="submit" class="btn btn-primary" @click="ExportAll()" style="float:right;font-size:12px;color:#fff;margin-right:5px;">
        <a id="Exportlink" href=""  ref="test" download="w3logo"></a>
        <i class="fa fa-download  "></i> 导出</button>
      </div>
      <div :is="currenTab" :agentID="agentTreeDataS" @esd="expended" @delegation='delegationvalue' @dealDetail='dealDetailvalue' @capital='capitalvalue' @order='ordervalue' @withdrawalDetail='withdrawalDetailvalue' @withCharge='withChargevalue'></div>
    </el-tabs>
          <div class="del-mask">
          <div class="mask_box">
              <div class="panel panel-default  no-border">
                <!-- Default panel contents -->
                <div class="panel-heading">导出所有</div>
                <div class="panel-body">
                  <form class="form-inline form-inline1" novalidate="" role="form">
                    <div>
                      <div class="error3">
                        <div class="messageinfo"></div>
                      </div>
                    </div>
                  </form>
                </div>
                <div class="closed closed-del" @click="closeDelMask()">×</div>
                <!-- Table -->
                <p>
                  <span class="fr">
                    <button type="button"  class="btn btn-info ExportAlls" style="color:#fff !important;" @click="closeDelMask1()">跳转到导出页面</button>
                  </span>
                  <span class="fr">
                    <button type="button" class="btn btn-default btn-q btn-q-del" @click="closeDelMask()">取消</button>
                  </span>
                </p>
              </div>
          </div>
        </div>
  </div>
</template>

<script>
import allClient from "./allCustomers/allCustomersS.vue";
import dealDetail from "./dealDetail/dealDetailS.vue";
import withdrawalDetail from "./withdrawalDetail/withdrawalDetailS.vue";
import delegation from "./delegation/delegationDetailS.vue";
import capital from "./capital/capitalS.vue";
import order from "./statics/StatisticsOrder/StatisticsOrderS.vue";
import profit from "./statics/StatisticsProfit/StatisticsProfitS.vue";
import withCharge from "./statics/StatisticsWithCharge/StatisticsWithChargeS.vue";
export default {
  // 客户查询
  name: "clientreports",
  components: {
    allClient, //所有客户
    dealDetail, //成交明细
    withdrawalDetail, //出入金明细
    delegation, //委托
    capital, //资金
    order, // 单量统计
    profit, // 结算单
    withCharge //持仓
  },
  data() {
    return {
      activeName: "",
      currenTab: "",
      filterText: "",
      agentTreeData: [
        {
          AgentCode: JSON.parse(sessionStorage.getItem("userInfo")).UserCode,
          AgentName: JSON.parse(sessionStorage.getItem("userInfo")).UserName,
          Childs: [],
          Level: 0,
          Parent: {}
        }
      ],
      agenttrees: [], //获取经纪人树
      //树形结构
      defaultProps: {
        id: "AgentCode",
        children: "Childs",
        label: "AgentName"
      },

      expandedKeys: [], //全局筛选后默认打开的节点

      agentTreeDataS: [JSON.parse(sessionStorage.getItem("userInfo")).UserCode],
      radio9: "1",
      agents: true,
      checkTypes: false,
      isderive:true,
      delegationvalueobj:{},
      dealDetailvalueobj:{},
      ordervalueobj:{},
      withdrawalDetailvalueobj:{},
      withChargevalueobj:{}
    };
  },
  created() {
    if (sessionStorage.getItem("tabnameC")) {
      this.activeName = sessionStorage.getItem("tabnameC");
      this.currenTab = sessionStorage.getItem("tabnameC");
    } else {
      this.activeName = "allClient";
      this.currenTab = "allClient";
    }
    this.$store.state.loaction = "/selects/clientreports";
  },
  mounted() {
    this.viewAgetnTree();
  },
  watch: {
    filterText(val) {
      this.$refs.tree2.filter(val);
    },
    activeName: function(newval, oldval) {
      if (newval == "profit") {
        $(".trees").animate({ width: "0px" });
        this.agents = false;
      } else {
        $(".trees").animate({ width: "195px" });
        this.agents = true;
      }
    },
    currenTab(val){
      if(this.currenTab == "profit" || this.currenTab == "allClient"){
          this.isderive = false
      }else{
          this.isderive = true;
      }
    }
  },
  methods: {
    handleClick(tab, event) {
      this.currenTab = tab.name;
      sessionStorage.setItem("tabnameC", tab.name);
    },
    checkTypechange(v) {
      if (v == 0) {
        this.checkTypes = true;
      } else {
        this.checkTypes = false;
      }
    },
    filterNode(value, data) {
      if (!value) return true;
      return data.AgentName.indexOf(value) !== -1;
    },
    //    获取经纪人树
    viewAgetnTree() {
      this.loading = true;
      this.$loginapi.post("/subagent/QueryAgentTree", null, e => {
        this.loading = false;
        if (e.Ret == 0) {
          // this.agenttrees = e.Data.Agents;
          this.agentTreeData[0].Childs = e.Data.Agents;
          if (e.Data.Agents != []) {
            // console.log(this.$store.state.userInfo);
            // this.agentTreeData[0].AgentCode = e.Data.Agents[0].Parent.AgentCode;
            // this.agentTreeData[0].AgentName = e.Data.Agents[0].Parent.AgentName;
          }

          if (e.Data.Agents.length > 0) {
            // if (this.toSelectCode != "") {
            //   this.getAllInfo(this.toSelectCode);
            //   setTimeout(this.selectTreeNode, 200);
            // } else {
            //   this.getAllInfo(e.Data.Agents[0].AgentCode);
            //   setTimeout(this.selectTreeNode, 200);
            // }
          }
        }
      });
    },
    getCheckedNodes(leafOnly, includeHalfChecked) {
      let temagentArray = this.$refs.tree2.getCheckedNodes();
      let agentArray = [];
      temagentArray.forEach(element => {
        agentArray.push(element.AgentCode);
      });
      this.agentTreeDataS = agentArray;
    },
    expended(val) {
      this.$store.state.agentstate = val;
      if (val != "AllAgent") {
        $(".trees").animate({ width: "0px" });
        this.agents = false;
      } else {
        $(".trees").animate({ width: "195px" });
        this.agents = true;
      }
      this.viewAgetnTree();
    },
    // 历史委托传值数据
    delegationvalue(val){
      this.delegationvalueobj = val;
    },
    // 历史成交明细
    dealDetailvalue(val){
      this.dealDetailvalueobj = val;
    },
    // 用户资金
    capitalvalue(val){
      this.capitalvalueobj = val;
    },
    // 单量统计
    ordervalue(val){
      this.ordervalueobj = val;
    },   
     // 出入金明细
    withdrawalDetailvalue(val){
      this.withdrawalDetailvalueobj = val;
    },
     // 出入金统计
    withChargevalue(val){
      this.withChargevalueobj = val;
    },    
            // 导出持仓
    ExportAll() {
              let url = "";
              let postData = {};
              // if(this.currenTab == "position"){   //代理佣金
              //   url = "report/ExportAgentDayCommissionHistory"
              //   postData = {
              //     BeginDate: this.delegationvalueobj.BeginDate,
              //     EndDate: this.delegationvalueobj.EndDate
              //   }
              // }else 
              if(this.currenTab == "delegation"){  //历史委托
                url = "report/ExportAgentUserHistoryOrder"
                postData = {
                  AgentIds:this.agentTreeDataS,
                  UserKey:this.UserKey,
                  ContractKey: this.delegationvalueobj.ContractKey,
                  PositionEffect: this.delegationvalueobj.PositionEffect,
                  BeginDate: this.delegationvalueobj.BeginDate,
                  EndDate: this.delegationvalueobj.EndDate
                }
              }else if(this.currenTab == "dealDetail"){  //历史成交明细
                url = "report/ExportAgentUserHistoryTrade"
                postData = {
                  AgentIds:this.agentTreeDataS,
                  UserKey:this.UserKey,
                  ContractKey: this.dealDetailvalueobj.ContractKey,
                  PositionEffect: this.dealDetailvalueobj.PositionEffect,
                  BeginDate: this.dealDetailvalueobj.BeginDate,
                  EndDate: this.dealDetailvalueobj.EndDate
                }
              }else if(this.currenTab == "capital"){ //用户资金
                url = "report/ExportAgentUserHistoryAccount"
                postData = {
                  AgentIds:this.agentTreeDataS,
                  UserKey:this.UserKey,
                  BeginDate: this.capitalvalueobj.BeginDate,
                  EndDate: this.capitalvalueobj.EndDate
                }
              }else if(this.currenTab == "order"){  //单量统计
                url = "report/ExportAgentHistoryTradeVolume"
                postData = {
                  AgentIds:this.agentTreeDataS,
                  UserKey:this.UserKey,
                  BeginTime:this.ordervalueobj.BeginTime,
                  EndTime:this.ordervalueobj.EndTime,
                  SortType:this.ordervalueobj.SortType,
                  Commodity:this.ordervalueobj.Commodity,
                  PositionEffect:this.ordervalueobj.PositionEffect
                }
              }else if(this.currenTab == "withdrawalDetail"){  //出入金明细
                url = "report/ExportAgentUserHistoryMoneyTransfer"
                postData = {
                  AgentIds:this.agentTreeDataS,
                  UserKey:this.UserKey,
                  BeginDate:this.withdrawalDetailvalueobj.BeginDate,
                  EndDate:this.withdrawalDetailvalueobj.EndDate,
                  MoneyTransType:this.withdrawalDetailvalueobj.MoneyTransType,
                  State:this.withdrawalDetailvalueobj.State,
                }
              }else if(this.currenTab == "withCharge"){   //出入金统计
                url = "report/ExportAgentUserHistoryMoneyTransferStatistical"
                postData = {
                  AgentIds:this.agentTreeDataS,
                  UserKey:this.UserKey,
                  BeginTime:this.withChargevalueobj.BeginTime,
                  EndTime:this.withChargevalueobj.EndTime,
                  MoneyTransType:this.withChargevalueobj.MoneyTransType,
                  SortType:this.withChargevalueobj.SortType,
                  State:this.withChargevalueobj.State
                }                
              }
              this.$loginapi.post(url, postData, response => {
                if (response.Ret == 0) {
                   $('.messageinfo').html(response.Msg);
                    $(".del-mask").fadeIn("fast");
                } else {
                  this.$message.error(response.Msg);
                }
              });
        },
        closeDelMask() {
          $(".del-mask").fadeOut("fast");
        },
        closeDelMask1() {

          $(".del-mask").fadeOut("fast");
          this.$router.push('/selects/exportdown');

        },
  }
};
</script>

<style lang="less" scoped>
.trees {
  width: 195px;
  height: 100%;
  float: left;
  border-right: 1px solid rgba(0, 0, 0, 0.15);
  .el-tree {
    height: calc(100% - 120px);
    overflow-x: scroll;
  }
}
.radios {
  padding: 0px 15px 0px;
}
.title_cc {
  height: 38px;
  line-height: 38px;
  font-size: 16px;
}
.derive{
    position: absolute;
    right: 15px;
    top: 10px;
    z-index: 9999999999;
}
</style>



// WEBPACK FOOTER //
// src/components/selects/clientreports.vue